import { lazy } from 'react';
import { useParams, type RouteObject } from 'react-router';
import { useWarehouseZoneDetailsQuery } from '../../api';

import locations from '../locations/route';

const DetailsPage = lazy(() => import('./details'));
const CreatePage = lazy(() => import('./create'));
const IndexPage = lazy(() => import('./index'));

export default {
    path: 'zones',
    title: 'Zone',
    Component: IndexPage,
    children: [{
        path: 'create',
        title: 'Dodaj zonu',
        Component: CreatePage,
    }, {
        path: ':zoneId',
        Title: () => {
            const { zoneId } = useParams<{ zoneId: string }>();
            const { data } = useWarehouseZoneDetailsQuery(zoneId!, { skip: !zoneId });
            return data ? data.name : null;
        },
        Component: DetailsPage,
        children: [locations],
    }],
} satisfies RouteObject;
